import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatExpansionModule} from '@angular/material/expansion';
import {TdoControlsModule} from '../tdo-controls/tdo-controls.module';
import {HomeAccordionComponent} from './home/controls/home-accordion/home-accordion.component';
import {HomeComponent} from './home/home.component';
import {RouterModule} from '@angular/router';
import {MatIconModule} from '@angular/material/icon';
import {FileManagerViewModule} from '../modules/file-manager/file-manager-view/file-manager-view.module';
import {MatTooltipModule} from '@angular/material/tooltip';
import { HomeCasesViewComponent } from './home/home-cases-view/home-cases-view.component';
import { HomeSubnavInfoViewComponent } from './home/home-subnav-info-view/home-subnav-info-view.component';
import { TdoSubnavComponent } from './controls/tdo-subnav/tdo-subnav.component';
import { TdoSubnavItemComponent } from './controls/tdo-subnav/tdo-subnav-item/tdo-subnav-item.component';
import {DirectivesModule} from '../directives/directives.module';
import { TdoNotesComponent } from './controls/tdo-notes/tdo-notes.component';
import {MatFormFieldModule} from '@angular/material/form-field';

import {MatSelectModule} from '@angular/material/select';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { RecentPatientsComponent } from './home/recent-patients/recent-patients.component';
import { HomeScheduleViewComponent } from './home/home-schedule-view/home-schedule-view.component';
import { TdoNotesMultiselectMenuComponent } from './controls/tdo-notes/tdo-notes-multiselect-menu/tdo-notes-multiselect-menu.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { SchedulerComponent } from './scheduler/scheduler.component';
import {SchedulingModule} from '../modules/scheduling/scheduling.module';
import { SchedulerViewOptionsComponent } from './scheduler/scheduler-view-options/scheduler-view-options.component';
import { SchedulerSubnavInfoViewComponent } from './scheduler/scheduler-subnav-info-view/scheduler-subnav-info-view.component';
import { SchedulerAccordionComponent } from './scheduler/controls/scheduler-accordion/scheduler-accordion.component';
import { SchedulerOperatorySelectorComponent } from './scheduler/scheduler-operatory-selector/scheduler-operatory-selector.component';
import { TdoNoteBuilderComponent } from './controls/tdo-note-builder/tdo-note-builder.component';
import {CdkDrag, DragDropModule} from '@angular/cdk/drag-drop';
import {MatButtonModule} from '@angular/material/button';
import {TdoMacroNotesComponent} from './controls/tdo-macro-notes/tdo-macro-notes.component';
import {MatTabsModule} from '@angular/material/tabs';
import {TdoOrganizerComponent} from './controls/tdo-organizer/tdo-organizer.component';
import {ImageOrganizerModule} from '../modules/imaging/image-organizer/image-organizer.module';
import { OrganizerComponent } from './organizer/organizer.component';
import { TdoImagingComponent } from './imaging/tdo-imaging.component';
import {ImageCollageModule} from '../modules/imaging/image-collage/image-collage.module';
import { ImagingToolsMenuComponent } from './imaging/imaging-tools-menu/imaging-tools-menu.component';
import { ImagingTopMenuComponent } from './imaging/imaging-top-menu/imaging-top-menu.component';
import {MatSliderModule} from '@angular/material/slider';
import { TdoImagingImageContainerComponent } from './imaging/tdo-imaging-image-container/tdo-imaging-image-container.component';
import { OrganizerContextMenuComponent } from './organizer/organizer-context-menu/organizer-context-menu.component';
import { TdoOrganizerFilterComponent } from './organizer/dialogs/tdo-organizer-filter/tdo-organizer-filter.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatInputModule} from '@angular/material/input';
import { TdoOrganizerCategorizeDialogComponent } from './organizer/dialogs/tdo-organizer-categorize-dialog/tdo-organizer-categorize-dialog.component';
import {TdoOrganizerRenameDialogComponent} from './organizer/dialogs/tdo-organizer-rename.dialog/tdo-organizer-rename-dialog.component';
import { TdoOrganizerSlideshowDialogComponent } from './organizer/dialogs/tdo-organizer-slideshow-dialog/tdo-organizer-slideshow-dialog.component';
import {NgxPanZoomModule} from 'ngx-panzoom';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { TdoPrePostOpControlComponent } from './controls/tdo-pre-post-op-control/tdo-pre-post-op-control.component';
import {MatRadioModule} from '@angular/material/radio';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatCardModule} from '@angular/material/card';
import {MatBadgeModule} from '@angular/material/badge';
import { TdoSmartSubnavComponent } from './controls/tdo-smart-subnav/tdo-smart-subnav.component';
import { TdoNotesExpandedComponent } from './controls/tdo-notes/tdo-notes-expanded/tdo-notes-expanded.component';
import { TdoNoteComponent } from './controls/tdo-notes/tdo-note/tdo-note.component';
import { ImagingCategoriesMenuComponent } from './imaging/imaging-categories-menu/imaging-categories-menu.component';
import {NgxDragResizeModule} from '@tdo-inc/ngx-drag-resize/dist/ngx-drag-resize';
import {TdoMultiselectDropdownModule} from '../tdo-controls/common/tdo-multiselect-dropdown/tdo-multiselect-dropdown.module';
import { TdoOrganizerRestoreDialogComponent } from './organizer/dialogs/tdo-organizer-restore.dialog/tdo-organizer-restore.dialog.component';
import { TdoGlobalSearchComponent } from './controls/tdo-global-search/tdo-global-search.component';
import { TdoOrganizerCaseToothDialogComponent } from './organizer/dialogs/tdo-organizer-case-tooth-dialog/tdo-organizer-case-tooth-dialog.component';
import {CaseFormsModule} from '../modules/case-forms/case-forms.module';
import {AngularSplitModule} from 'angular-split';
import { TdoSmartnavComponent } from './controls/tdo-smartnav/tdo-smartnav.component';
import {MatMenuModule} from '@angular/material/menu';
import { TdoImagingContextmenuComponent } from './imaging/tdo-imaging-contextmenu/tdo-imaging-contextmenu.component';
import { ImagingCalibrationComponent } from './imaging/imaging-calibration/imaging-calibration.component';
import { TdoInstantMessagingComponent } from './controls/tdo-instant-messaging/tdo-instant-messaging.component';
import { NoteDialogComponent } from './controls/tdo-notes/tdo-note/dialog/note-dialog/note-dialog.component';
import { PipeModule } from '../pipes/pipe.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MaterialModule } from '../modules/material.module';



@NgModule({
  declarations: [
    HomeComponent,
    HomeAccordionComponent,
    HomeCasesViewComponent,
    HomeSubnavInfoViewComponent,
    TdoSubnavComponent,
    TdoSubnavItemComponent,
    TdoNotesComponent,
    RecentPatientsComponent,
    HomeScheduleViewComponent,
    TdoNotesMultiselectMenuComponent,
    SchedulerComponent,
    SchedulerViewOptionsComponent,
    SchedulerSubnavInfoViewComponent,
    SchedulerAccordionComponent,
    SchedulerOperatorySelectorComponent,
    TdoNoteBuilderComponent,
    TdoMacroNotesComponent,
    TdoOrganizerComponent,
    OrganizerComponent,
    TdoImagingComponent,
    ImagingToolsMenuComponent,
    ImagingTopMenuComponent,
    TdoImagingImageContainerComponent,
    OrganizerContextMenuComponent,
    TdoOrganizerFilterComponent,
    TdoOrganizerCategorizeDialogComponent,
    TdoOrganizerRenameDialogComponent,
    TdoOrganizerSlideshowDialogComponent,
    TdoPrePostOpControlComponent,
    TdoSmartSubnavComponent,
    TdoNotesExpandedComponent,
    TdoNoteComponent,
    ImagingCategoriesMenuComponent,
    TdoOrganizerRestoreDialogComponent,
    TdoGlobalSearchComponent,
    TdoOrganizerCaseToothDialogComponent,
    TdoSmartnavComponent,
    TdoImagingContextmenuComponent,
    ImagingCalibrationComponent,
    TdoInstantMessagingComponent,
    NoteDialogComponent
    
  ],
    imports: [
        MatExpansionModule,
        MatIconModule,
        MatTooltipModule,
        MatFormFieldModule,
        MatSelectModule,
        TdoControlsModule,
        RouterModule,
        FileManagerViewModule,
        DirectivesModule,
        ReactiveFormsModule,
        FormsModule,
        MatCheckboxModule,
        SchedulingModule,
        DragDropModule,
        MatButtonModule,
        MatTabsModule,
        ImageOrganizerModule,
        ImageCollageModule,
        MatSliderModule,
        MatDatepickerModule,
        MatInputModule,
        NgxPanZoomModule,
        PdfViewerModule,
        MatAutocompleteModule,
        MatRadioModule,
        MatButtonToggleModule,
        MatGridListModule,
        MatCardModule,
        MatBadgeModule,
        NgxDragResizeModule,
        TdoMultiselectDropdownModule,
        CaseFormsModule,
        AngularSplitModule,
        MatMenuModule,
        CommonModule,   
        PipeModule,
        MatProgressBarModule,
        MaterialModule
    ],
  exports: [
    HomeComponent,
    TdoNoteBuilderComponent,
    TdoMacroNotesComponent,
    TdoOrganizerComponent,
    TdoGlobalSearchComponent,
    TdoInstantMessagingComponent,
    TdoNotesExpandedComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class MainInterfaceModule { }
